import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";

// Click action that fetches an <a href> as a Turbo Stream and applies the
// returned actions. The address bar URL is intentionally left untouched.
//
// Use for filter links (status pills, Review Drafts) inside a turbo-frame
// where you want a stream-based partial update instead of a frame swap that
// re-renders the whole frame.
export default class extends Controller {
  async visit(event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.currentTarget;
    if (!link || !link.href) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const response = await fetch(link.href, {
      headers: { Accept: "text/vnd.turbo-stream.html, text/html" },
      credentials: "same-origin",
    });
    const text = await response.text();
    Turbo.renderStreamMessage(text);
  }
}
